import DailyOutputReportPage from "./DailyOutputReportPage";

export default function DailyPersonnelOutputPage() {
  return (
    <DailyOutputReportPage
      title="Daily Personnel Output"
      label="Personnel"
      endpoint="/reports/daily-personnel-output"
      detailEndpoint="/reports/daily-personnel-output/details"
      detailParamName="person"
      exportEndpoint="/reports/daily-personnel-output/export"
      filterEndpoint="/reports/personnel-list"
      filterLabel="Personnel"
      filterParamName="personnel"
      exportFilenamePrefix="Daily_Personnel_Output"
      showCompanyFilter
      nameExtractor={(name) => {
        const match = name.match(/^(.+)\s+\(.*\)$/);
        return match ? match[1] : name;
      }}
    />
  );
}
